


































































import Vue from "vue";
import Component from "vue-class-component";
import {useRentalStore} from "@/store/rental";
import type {RentalRequest} from "@/api/models/rental";
import {RentalRequestStatus, RentalRequestStatusLabels} from "@/api/models/rental";
import dayjs from "dayjs";

@Component({
  metaInfo: {
    title: "Meine Leihanfragen",
  },
})
export default class MyRentalRequests extends Vue {
  public isLoading = true;

  public get myRequests(): RentalRequest[] {
    return useRentalStore().myRentalRequests;
  }

  public async mounted(): Promise<void> {
    await this.loadRequests();
  }

  public async loadRequests(): Promise<void> {
    this.isLoading = true;
    try {
      const rentalStore = useRentalStore();
      await rentalStore.fetchMyRentalRequests(true);
    } catch (e) {
      console.error("Error loading my rental requests:", e);
    } finally {
      this.isLoading = false;
    }
  }

  public formatDate(dateString: string): string {
    return dayjs(dateString).format("DD.MM.YYYY");
  }

  public getStatusLabel(status: RentalRequestStatus): string {
    return RentalRequestStatusLabels[status] || "Unbekannt";
  }

  public getStatusBadgeClass(status: RentalRequestStatus): string {
    switch (status) {
      case RentalRequestStatus.Pending:
        return "bg-warning text-dark";
      case RentalRequestStatus.Confirmed:
        return "bg-success";
      case RentalRequestStatus.Rejected:
        return "bg-danger";
      case RentalRequestStatus.Completed:
        return "bg-info";
      default:
        return "bg-secondary";
    }
  }
}
